import React from 'react'

const Loader = () => {
    return (
        <div className="preloader" >
            <div className="box">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader